import { render, staticRenderFns } from "./DetailSection.vue?vue&type=template&id=ab6389da&scoped=true"
import script from "./DetailSection.vue?vue&type=script&lang=js"
export * from "./DetailSection.vue?vue&type=script&lang=js"
import style0 from "./DetailSection.vue?vue&type=style&index=0&id=ab6389da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab6389da",
  null
  
)

export default component.exports